import { useRef } from 'react';

export const useLatest = (current) => {
  const storedValue = useRef(current);
  storedValue.current = current;
  return storedValue;
};
